import { CONTRACT_STATUS_ACCEPTED } from "@lhd/components/SideBar/constants";
import { user } from "@lhd/features/users/selector";
import { getCompanyId } from "@lhd/utility";
import { useCallback } from "react";

import { useSelector } from "react-redux";
import { Worker } from "types/worker.type";
export const useGetAuth = () => {
  const companyId = getCompanyId();
  const auth = useSelector(user);
  const isAdmin = !!auth?.is_admin;
  const isOnCompanyAdmin = !!auth?.is_on_company_admin;
  const isRootCompany = !!auth?.is_root_company;
  const isSuperAdmin = isAdmin && (isOnCompanyAdmin || isRootCompany);
  const currentContractStatus = auth?.current_contract_status;
  const canChangeUser = !!auth?.can_change_user || isAdmin;
  const canChangeOrgChart = !!auth?.can_change_org_chart;
  const firstWorker = auth?.workers?.[0];
  const isSpecialSuperAdmin = isAdmin && isOnCompanyAdmin && isRootCompany;
  const isSupperAdminLoggingIn = !!auth?.is_super_admin_user;
  const isUserResigned = !!auth?.is_retired;

  const getCurrentCompany = useCallback(
    (defaultCompanyId?: number) => {
      const companyId = defaultCompanyId || getCompanyId();
      return auth?.companies.find(
        (company) => company.id.toString() == companyId,
      );
    },
    [companyId, auth?.companies],
  );

  const getCurrentWorker = useCallback(() => {
    return auth?.workers?.find(
      (i: any) => Number(i?.company_id) === Number(companyId),
    );
  }, [companyId, auth?.workers]);

  const getIsContractStatusAccepted = useCallback(
    (defaultCompanyId?: number) => {
      const companyId = defaultCompanyId || getCompanyId();
      const contractStatus = auth?.companies.find(
        (company) => company.id.toString() == companyId,
      )?.contract_status;

      return CONTRACT_STATUS_ACCEPTED.includes(
        contractStatus as typeof CONTRACT_STATUS_ACCEPTED[number],
      );
    },
    [auth?.companies],
  );

  const getCurrentWorkerWithIdParams = useCallback(
    (workerId: string) => {
      return !!auth?.workers?.find(
        (i: Worker) => Number(i?.id) === Number(workerId),
      );
    },
    [auth?.workers],
  );

  const getWorkerById = useCallback(
    (workerId: string) => {
      return auth?.workers?.find(
        (i: Worker) => Number(i?.id) === Number(workerId),
      );
    },
    [auth?.workers],
  );

  return {
    isAdmin,
    isSuperAdmin,
    canChangeUser,
    currentContractStatus,
    isRootCompany,
    getCurrentCompany,
    getCurrentWorker,
    getIsContractStatusAccepted,
    isOnCompanyAdmin,
    firstWorker,
    companies: auth?.companies || [],
    auth,
    canChangeOrgChart,
    isSpecialSuperAdmin,
    getCurrentWorkerWithIdParams,
    isSupperAdminLoggingIn,
    isUserResigned,
    getWorkerById,
  };
};
